export default __webpack_public_path__ + "static/media/59t.270a539b.jpg";